import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        font-family: 'Montserrat';\n        font-size: ", ";\n        line-height: ", ";\n        font-weight: ", ";\n        padding: ", ";\n        color: ", ";\n        user-select: none;\n        cursor: pointer;\n\n        ", "\n\n        ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &:hover {\n        background: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
export var HoveredStyledOption = function HoveredStyledOption(props) {
  return css(_templateObject(), props.theme.components.select.hoverColor);
};
export var StyledOption = styled.div(_templateObject2(), function (props) {
  return css(_templateObject3(), props.theme.components.input.fontSize, props.theme.components.input.lineHeight, props.theme.components.input.inputText.fontWeight, props.theme.components.input.inputText.padding, props.theme.components.input.inputText.color, props.noHover ? '' : HoveredStyledOption(props), props.selected ? "background: ".concat(props.theme.components.select.hoverColor, ";") : '');
});